module.exports = __webpack_public_path__ + "static/media/bellabyte-newsletter-email-marketing.8188fe7f.jpg";